import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import Header from '@/lib/header/Header';
import Footer from '@/lib/header/Footer';
import Providers from '@/components/Providers';
const RootLayout = () => (
    <>
        <Providers>
            <div className='flex min-h-screen flex-col'>
                <Header />
                <div className='flex-1'>
                    <Outlet />
                </div>
                <Footer />
            </div>
        </Providers>
        <TanStackRouterDevtools />
    </>
);

export const Route = createRootRoute({ component: RootLayout });
